import { r as registerInstance, h } from './index-16dc7dde.js';
import './request.constants-deb285e0.js';
import { o as productCtas } from './utils-15ad90ec.js';
import { r as requestRangeSelectorConfig } from './helper-a93ee129.js';
import { u as updateProductCtasSelectorSettings } from './product-selector-utils-92375719.js';
import { T as TAB_NAMES } from './constants-74678075.js';
import { g as getFilteredBreadcrumbs } from './utils-400179ea.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './_commonjsHelpers-ba3f0406.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './types-aae419ee.js';

const PBS_BACKGROUND_COLOR = '#FFF';

let ProductAppRange = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productCtas = productCtas;
    this.isTabsInitialized = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.productCtasState = this.productCtas;
    this.productSelector = null;
    this.SE_BRAND = 'se';
    this.requestRangeSelectorConfigCreator = () => requestRangeSelectorConfig(this.host, this.rangeId, {
      countryCode: this.countryCode,
      languageCode: this.languageCode,
      brand: this.SE_BRAND,
    });
  }
  productCtasDidChange(newProductCtas) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.productSelector, this.productCtas.buttons);
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs((_a = this.mainInfo) === null || _a === void 0 ? void 0 : _a.breadcrumbs);
  }
  getRichText(content) {
    const { richText } = content;
    const richTextResponse = richText || content.MainContent[0].richText;
    return richTextResponse === null || richTextResponse === void 0 ? void 0 : richTextResponse.map((item) => item.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim());
  }
  render() {
    const { image, name, description, masterRangeName, longDescription, rangePartofLabel } = this.mainInfo;
    return (h("se-container", { display: "block", style: {
        'background-color': PBS_BACKGROUND_COLOR,
      } }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: false, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs" })), h("pes-range-main", { host: this.host, endpoint: this.endpoint, rangePartofLabel: rangePartofLabel, commercialStatus: this.mainInfo.commercialStatus, description: description, image: image, longDescription: longDescription, masterRangeName: masterRangeName, name: name, brandLogo: this.mainInfo.brandLogo, id: this.mainInfo.id, localeCode: `${this.countryCode.toUpperCase()}/${this.languageCode}`, rangeCtas: this.mainInfo.rangeCtas, requestRangeSelectorConfig: this.requestRangeSelectorConfigCreator, readMoreLabel: this.mainInfo.readMoreLabel, readLessLabel: this.mainInfo.readLessLabel, learnMoreLabel: this.mainInfo.learnMoreLabel, moreOptionsLabel: this.mainInfo.moreOptionsLabel }), this.tabs.tabs && (h("pes-spryker-range-tabs", { tabs: this.tabs.tabs, appProductsLabel: this.mainInfo.appProductsLabel, commonFiltersFilterBy: this.mainInfo.commonFiltersFilterBy, facetButtonResetAllLabel: this.mainInfo.facetButtonResetAllLabel, facetButtonViewLessFilters: this.mainInfo.facetButtonViewLessFilters, facetButtonViewMoreFilters: this.mainInfo.facetButtonViewMoreFilters, nextLabel: this.mainInfo.nextLabel, pageLabel: this.tabs.pageLabel, noResultsClearLink: this.mainInfo.noResultsClearLink, noResultsHeader: this.mainInfo.noResultsHeader, noResultsMessage: this.mainInfo.noResultsMessage, numberProductsOfAllProductsLabel: this.mainInfo.numberProductsOfAllProductsLabel, previousLabel: this.mainInfo.previousLabel, rangeProductLabel: this.mainInfo.rangeProductLabel, rangeProductsFiltersLabel: this.mainInfo.rangeProductsFiltersLabel, viewLessLabel: this.mainInfo.viewLessLabel, viewMoreLabel: this.mainInfo.viewMoreLabel, viewProductsLabel: this.mainInfo.viewProductsLabel, rangePresentationLabel: this.mainInfo.rangePresentationLabel, loadMoreLabel: this.tabs.loadMoreLabel, loadPreviousLabel: this.tabs.loadPreviousLabel, backLabel: this.mainInfo.backLabel, localeCode: `/${this.countryCode}/${this.languageCode}`, rangeReference: this.mainInfo.rangeReference, host: this.host, endpoint: this.endpoint, rangeSoftwareAndFirmwareLabel: this.tabs.rangeSoftwareAndFirmwareLabel, rangeWebinarsAndResourcesLabel: this.tabs.rangeWebinarsAndResourcesLabel, softwareRegistrationLabel: this.tabs.softwareRegistrationLabel, descriptionBigger: this.mainInfo.descriptionBigger, id: this.mainInfo.id, name: name, navigationState: this.mainInfo.navigationState, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, productCtas: this.productCtasState, isPBS: true, documentListing: this.documentListing })), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-range__section" }))));
  }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};

export { ProductAppRange as pes_app_spryker_range };
